/**
 * A bundle price for display, e.g. "£479.52". Without a currency (tenant settings not loaded),
 * or with one Intl doesn't know, just the number with two decimals.
 */
export const formatBundlePrice = (cost: number, currencyCode: string | null, language: string): string => {
    if (currencyCode) {
        try {
            return cost.toLocaleString(language, { style: "currency", currency: currencyCode });
        } catch {
            // Invalid currency code, fall through
        }
    }
    return cost.toLocaleString(language, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
